import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { isNonEmptyString, createCustomPropType } from '../../../../js/app/react/validators';
import View from './HasYourFamilyStartedSavingView';
import {
  currentClientId,
  data2 as data2Selector,
  isPopulatedSelector,
} from '../../AdvWorkflow/AdvWorkflowSelector';
import { updateSupportData } from '../../AdvWorkflow/AdvWorkflowActions';
import { BACKEND_KEY } from '../AccountsWorkflowConstants';
import * as PersonalInfoConstants from '../../PersonalInfoWorkflow/PersonalInfoWorkflowConstants';
import { accountsSelector } from './AccountsStep/AccountsStepSelector';
import { WORKFLOW_ID as EDUCATION_WORKFLOW_ID } from '../../EducationWorkflow/EducationWorkflowConstants';
import { WORKFLOW_ID as HOME_PURCHASE_WORKFLOW_ID } from '../../HomePurchaseWorkflow/HomePurchaseWorkflowConstants';
import { WORKFLOW_ID as LARGE_PURCHASE_WORKFLOW_ID } from '../../LargePurchaseWorkflow/LargePurchaseWorkflowConstants';
import { WORKFLOW_ID as EMERGENCY_FUND_WORKFLOW_ID } from '../../EmergencyFundWorkflow/EmergencyFundWorkflowConstants';
import { WORKFLOW_ID as HEALTHCARE_WORKFLOW_ID } from '../../HealthcareWorkflow/HealthcareWorkflowConstants';
import { getSelectedChildFirstName } from '../../ChildrenInfoWorkflow/ChildrenInfoWorkflowSelector';

const getTitle = (state, ownProps) => {
  if (ownProps.workflowId === EDUCATION_WORKFLOW_ID) {
    const childFirstName = getSelectedChildFirstName(state, ownProps);
    return `Have you started saving for ${childFirstName}'s education?`;
  }

  if (ownProps.workflowId === HEALTHCARE_WORKFLOW_ID) {
    return 'Have you started saving for your healthcare costs?';
  }

  if (ownProps.workflowId === HOME_PURCHASE_WORKFLOW_ID) {
    return 'Have you started saving for your home purchase?';
  }

  if (ownProps.workflowId === LARGE_PURCHASE_WORKFLOW_ID) {
    return 'Have you started saving for your large purchase?';
  }

  if (ownProps.workflowId === EMERGENCY_FUND_WORKFLOW_ID) {
    return 'Have you started building your emergency fund?';
  }

  const hasFamily =
    data2Selector(state, ownProps)(`${PersonalInfoConstants.BACKEND_KEY}.HasPartner`) ||
    data2Selector(state, ownProps)(`${PersonalInfoConstants.BACKEND_KEY}.HasChildren`);

  if (hasFamily) {
    return 'Has your family started saving for retirement?';
  }

  return 'Have you started saving for retirement?';
};

const mapStateToProps = (state, ownProps) => ({
  clientId: currentClientId(state, ownProps),
  accounts: accountsSelector(state, ownProps),
  hasYourFamilyStartedSaving: data2Selector(state, ownProps)(`${BACKEND_KEY}.HasYourFamilyStartedSaving`),
  alreadyHasYourFamilyStartedSavingData: !!data2Selector(state, ownProps)(`${BACKEND_KEY}.AlreadyHasYourFamilyStartedSavingData`),
  title: getTitle(state, ownProps),
  isPopulated: isPopulatedSelector(state, ownProps),
});
const mapDispatchToProps = dispatch => ({
  preprocessData: (clientId, accounts, store2) => {
    if (accounts.length > 0) {
      store2(
        {
          [BACKEND_KEY]: {
            HasYourFamilyStartedSaving: true,
            AlreadyHasYourFamilyStartedSavingData: true,
          },
        },
        clientId,
      );
    }
  },
  store2: workflowId => (data, clientId) => dispatch(updateSupportData(data, workflowId, clientId)),
});

const HasYourFamilyStartedSavingContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(View);

HasYourFamilyStartedSavingContainer.propTypes = {
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
};

export default HasYourFamilyStartedSavingContainer;
